// @flow

import React from 'react';

type Props = {
  commonTranslations: TranslationType,
  isLoggedIn: boolean,
  logout: Function,
};

const MobileLoginLogoutBtn = ({ commonTranslations, isLoggedIn, logout }: Props) => {
  if (isLoggedIn) {
    return (
      <a className="button mobile-login-button sm" onClick={() => logout()} href="/">
        <span>{commonTranslations.logout}</span>
      </a>
    );
  }
  return (
    <a className="button mobile-login-button sm" href="/login">
      <span>{commonTranslations.login}</span>
    </a>
  );
};

MobileLoginLogoutBtn.defaultProps = {
  commonTranslations: {},
  isLoggedIn: false,
  logout: () => {},
};

export default MobileLoginLogoutBtn;
